module.exports = __webpack_public_path__ + "static/img/40.2b8929bd.gif";